const keyFor = (userId, accountId) =>
  `talkvia:last-conversation:${userId}:${accountId}`;
const validId = value => /^[1-9]\d*$/.test(String(value || ''));

export function rememberConversation(to, userId, enabled) {
  const { accountId, conversation_id: conversationId } = to.params || {};
  if (!validId(userId) || !validId(accountId)) return;
  try {
    const key = keyFor(userId, accountId);
    if (!enabled) {
      sessionStorage.removeItem(key);
    } else if (
      validId(conversationId) &&
      to.path?.includes('/conversations/')
    ) {
      sessionStorage.setItem(key, String(conversationId));
    }
  } catch {
    // Browsers that block storage should retain normal navigation.
  }
}

export async function restoreConversation(to, from, userId, enabled, verify) {
  const accountId = to.params?.accountId;
  if (
    !enabled ||
    to.name !== 'talkvia_conversations' ||
    from.params?.conversation_id ||
    !validId(userId) ||
    !validId(accountId) ||
    Object.keys(to.query || {}).length
  )
    return null;
  try {
    const key = keyFor(userId, accountId);
    const conversationId = sessionStorage.getItem(key);
    if (!validId(conversationId)) return null;
    try {
      await verify(accountId, conversationId);
    } catch (error) {
      if ([403, 404].includes(error.response?.status))
        sessionStorage.removeItem(key);
      return null;
    }
    return {
      name: 'inbox_conversation',
      params: { accountId, conversation_id: conversationId },
      replace: true,
    };
  } catch {
    return null;
  }
}
